import { render, staticRenderFns } from "./appInfo_desktop.vue?vue&type=template&id=3b23a079&scoped=true&"
import script from "./appInfo_desktop.vue?vue&type=script&lang=js&"
export * from "./appInfo_desktop.vue?vue&type=script&lang=js&"
import style0 from "./appInfo_desktop.vue?vue&type=style&index=0&id=3b23a079&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b23a079",
  null
  
)

export default component.exports